import { API, GraphQLQuery } from "@aws-amplify/api";
import { useQuery } from "@tanstack/react-query";
import { createContext, FC, useContext } from "react";
import { useNavigate } from "react-router";
import { Button, Dropdown, Header, Icon, List } from "semantic-ui-react";
import { GetUserInfoQuery } from "./API";
import { User } from "./auth/auth";
import { getUserInfo } from "./graphql/queries";
import { useChild } from "./hooks";
import { Link } from "react-router-dom";

export const accountId = createContext("")

export function useAccounts() {
  const [email] = useChild(useContext(User), 'email')
  return useQuery({
    queryKey: [getUserInfo, email],
    queryFn: async () => (await API.graphql<GraphQLQuery<GetUserInfoQuery>>({
      query: getUserInfo,
      variables: {
        userId: email
      }
    })).data
  })
}

interface AccountDropdownProps {
  navigatePath: string
}

export const AccountDropdown: FC<AccountDropdownProps> = ({ navigatePath }) => {
  const {isLoading, data, refetch} = useAccounts()
  const navigate = useNavigate()
  const aid = useContext(accountId)
  
  const accounts = data?.getUserInfo?.accounts?.items;

  return (
    <List horizontal>
      <List.Item><Header as='h4'>AWS Account:</Header></List.Item>
      <List.Item>
        <Dropdown placeholder='select account'
                      fluid
                      selection
                      loading={isLoading}
                      value={aid}
                      defaultValue={accounts?.at(0)?.accountId}
                      onChange={(e, data) => {
                        navigate(navigatePath.replace('ACCOUNT_ID', data.value as string))
                      }}
                      options={accounts?.filter(Boolean).map((account) => ({
                        key: account!!.accountId,
                        text: '' + account!!.accountId + 
                          ((account!!.accountName && account?.accountName !== account?.accountId &&
                            ' - ' + account?.accountName) || ''),
                        value: account!!.accountId,
                      })) || []}
      />
      </List.Item>
      <List.Item>
        <Button icon='refresh' onClick={() => refetch()} loading={isLoading}/>
      </List.Item>

    </List>
  )
}